export const IconRightArrowCarousel = `<svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#a)">
    <g clip-path="url(#b)" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">
      <path d="m16.521 12.324 5.408-5.155-5.408-5.493m4.817 5.409H3.676"/>
    </g>
  </g>
  <defs>
    <clipPath id="b">
      <path fill="#fff" d="M3 1h19.606v12H3z"/>
    </clipPath>
    <filter id="a" x="0" y="0" width="25.605" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="2"/>
      <feGaussianBlur stdDeviation="1.5"/>
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"/>
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_593_681"/>
      <feBlend in="SourceGraphic" in2="effect1_dropShadow_593_681" result="shape"/>
    </filter>
  </defs>
</svg>
`
